const tableCellUser = {
  photo: 'FOTO',
  Typography: 'Nenhum resultado encontrado'
};

export default tableCellUser;
